// src/pages/AuthPages/Login/AccountSetupRequiredModal.js
import { Dialog, DialogTitle, DialogContent, Box } from "@mui/material";
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import { useTheme } from "@mui/material/styles";
import warning from "../../../assets/warning.svg";
import { useTranslation } from "react-i18next";

// Shown when a company-admin-invited worker tries to log in before verifying
// their email and/or before the admin has activated their account
// (worker.status === "invited" on the backend, response status: "setup_required").
const AccountSetupRequiredModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: { borderRadius: "13px", p: 2 },
      }}
    >
      <DialogTitle sx={{ textAlign: "center" }}>
        <img src={warning} style={{ width: 70, height: 70 }} alt="warning" />
      </DialogTitle>

      <DialogContent>
        <CustomText
          sx={{
            ...textStyles,
            fontSize: "22px",
            fontWeight: 500,
            fontFamily: "Poppins, sans-serif",
            color: theme.palette.tertiary.main,
            textAlign: "center",
            mb: 2,
          }}
        >
          {t("accountSetupRequiredModal.title")}
        </CustomText>

        <CustomText
          sx={{
            ...textStyles.body4,
            color: theme.palette.text.primary,
            textAlign: "center",
            mb: 3,
          }}
        >
          {t("accountSetupRequiredModal.description")}
        </CustomText>

        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CustomButton
            onClick={onClose}
            size="medium"
            fullWidth
            label={t("accountSetupRequiredModal.close")}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AccountSetupRequiredModal;
